import React from "react";

import pdf from "@react-pdf/renderer";

import { colors } from "@/theme/overrides/colors";

const { View, StyleSheet } = pdf;

const styles = StyleSheet.create({
  root: {
    width: "100%",
  },
  normal: {
    backgroundColor: "#C0C5CD",
    height: "1px",
  },
  large: {
    backgroundColor: colors.dark,
    height: "2px",
  },
});

type Props = {
  size?: "normal" | "large";
};
const Subheader: React.FC<Props> = ({ size = "normal" }) => (
  <View style={[styles.root, styles[size]]} />
);

export default Subheader;
